import "./NavBar.css";
import "./AvatarMenu.css";
import React, { useEffect, useRef, useState } from "react";

import { APP_NAME } from "../../data/config.js";
import { Link, useLocation, useMatch, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/AuthProvider.jsx";
import NavBar from "./NavBar.jsx";
import {
  FaThLarge,
  FaChalkboardTeacher,
  FaHeart,
  FaUserEdit,
  FaSignOutAlt,
} from "react-icons/fa";

function StudentNavBar() {
  const { user, isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false); // mobile nav-links
  const [menuOpen, setMenuOpen] = useState(false); // avatar dropdown
  const ref = useRef(null);
  const menuRef = useRef(null);
  const location = useLocation();
  const isSearchPage = useMatch("/:category/:mode/:subject");

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close the dropdown whenever the route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  if (!isLoggedIn) {
    return <NavBar />;
  }

  const go = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="logo">
          <a href="/">
            <img src="/x-icon.png" />
            <span>{APP_NAME.substring(0, 6)}</span>
            <span>{APP_NAME.substring(6)}</span>
          </a>
        </div>
        <ul className={`nav-links ${open ? "mobile" : ""}`} ref={ref}>
          <li>
            <Link
              to="/categories"
              className={`nav-link ${isSearchPage || location.pathname === "/all-categories/any-mode/all-subjects" ? "active" : ""}`}
            >
              Find Tutors
            </Link>
          </li>
          <li>
            <Link
              to="/categories"
              className={`nav-link ${location.pathname === "/blogs" ? "active" : ""}`}
            >
              Category
            </Link>
          </li>
          <li>
            <Link
              to="/phd-mentorship"
              className={`nav-link ${location.pathname === "/phd-mentorship" ? "active" : ""}`}
            >
              PhD Mentorship
            </Link>
          </li>
          <li>
            <Link
              to="/ai-note-maker"
              className={`nav-link ${location.pathname === "/ai-note-maker" ? "active" : ""}`}
            >
              AI Note Maker
            </Link>
          </li>
        </ul>
      </div>

      <div className="navbar-right">
        <div className="nav-actions">
          <div className="avatar-menu-wrap" ref={menuRef}>
            <button
              className="avatar-trigger"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="Account menu"
            >
              <img
                src={`${import.meta.env.VITE_APP_BASE_URL}/${user?.profilePhoto ?? ""}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = import.meta.env.VITE_PROFILE_PHOTO_PLACEHOLDER;
                }}
                className="avatar"
              />
            </button>

            {menuOpen && (
              <div className="avatar-dropdown">
                <div className="avatar-dropdown-head">
                  <div className="name">{user?.fullName || "Student"}</div>
                  <div className="email">{user?.email || ""}</div>
                </div>

                <button onClick={() => go("/dashboard")}>
                  <span className="mi"><FaThLarge /></span> Dashboard
                </button>
                <button onClick={() => go("/dashboard?tab=classes")}>
                  <span className="mi"><FaChalkboardTeacher /></span> My Classes
                </button>
                <button onClick={() => go("/dashboard?tab=favourites")}>
                  <span className="mi"><FaHeart /></span> Favourites
                </button>
                <button onClick={() => go("/dashboard?tab=profile")}>
                  <span className="mi"><FaUserEdit /></span> Update Profile
                </button>

                <button className="danger" onClick={() => { setMenuOpen(false); logout(); }}>
                  <span className="mi"><FaSignOutAlt /></span> Logout
                </button>
              </div>
            )}
          </div>
        </div>
        <button className="menu-btn" onClick={() => setOpen(!open)}>
          <i className="fas fa-bars" />
        </button>
      </div>
    </nav>
  );
}

export default StudentNavBar;
